module.exports = __webpack_public_path__ + "img/lms-theme-loop-logo-with-link.8c2f55f5.svg";